import styled from '@emotion/styled';
import { fadeIn } from 'src/domains/layouts/shared/Animation.style';
import { withConfig } from 'src/withConfig';
import { InfoIcon } from 'src/domains/layouts/shared/assets/icons/InfoIcon';

interface AlertBannerInlineWrapperPropsType {
    className?: string;
    dataTest?: string;
    marginBottom?: string;
    marginTop?: string;
    size: 'small' | 'medium';
}

export const AlertBannerInlineWrapper = withConfig(theme => styled('div', { label: 'AlertBannerInlineWrapper' }) <AlertBannerInlineWrapperPropsType>`
    animation: ${fadeIn} .2s ease forwards;
    color: ${theme.star.betslipGeneral.txtColor};
    display: flex;
    flex-flow: row nowrap;
    font-size: ${({ size }): string => size === 'small' ? theme.star.fontSize.xSmall : theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: ${({ size }): string => size === 'small' ? '1.2' : '1.3334'};
    margin-bottom: ${({ marginBottom }): string => marginBottom === undefined ? '0' : marginBottom};
    margin-top: ${({ marginTop }): string => marginTop === undefined ? '0' : marginTop};
    padding: 2px 0 2px 24px;
    position: relative;
    text-align: left;
`);

export const InfoIconWrapper = styled(InfoIcon, { label: 'InfoIconWrapper' })`
    fill: currentcolor;
    flex: 0 0 16px;
    height: 16px;
    left: 0;
    position: absolute;
    top: 0;
    width: 16px;
`;
